<template>
  <v-app>
    <Header/>
    <v-content class="contentva">
      <v-container fluid full-width class="pa-0">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import Header from './components/inc/header'
  export default {
    components:{Header}

  }
</script>
<style scoped>
.contentva{
  background:#f3f5f9;
}
</style>
